export const PRODUCT_LISTING_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "CollectionPage",
      "@id": "https://elchemy.com/product/#webpage",
      url: "https://elchemy.com/product",
      name: "Source High-Quality Chemicals for Every Industry | Elchemy",
      description:
        "Explore our full range of high-quality ingredients—backed by global compliance, consistent supply, and technical expertise. From formulation to fulfillment, we've got you covered.",
      isPartOf: { "@id": "https://elchemy.com/#website" },
      publisher: { "@id": "https://elchemy.com/#organization" },
      mainEntity: { "@id": "https://elchemy.com/product/#itemlist" },
    },
    {
      "@type": "ItemList",
      "@id": "https://elchemy.com/product/#itemlist",
      name: "Elchemy Industrial Chemicals Product Range",
      description:
        "A comprehensive list of specialty chemicals including Cetyl Alcohol, Caustic Soda, SLES, LABSA, and more, available for global distribution.",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Cetyl Alcohol",
          url: "https://elchemy.com/product/cetyl-alcohol-188",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Caustic Soda Flakes",
          url: "https://elchemy.com/product/caustic-soda-flakes-189",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: "Sodium Laureth Sulphate (SLES)",
          url: "https://elchemy.com/product/sodium-laureth-sulphate-sles-190",
        },
        {
          "@type": "ListItem",
          position: 4,
          name: "Linear Alkylbenzene Sulfonic Acid (LABSA)",
          url: "https://elchemy.com/product/linear-alkylbenzene-sulfonic-acid-labsa-191",
        },
        {
          "@type": "ListItem",
          position: 5,
          name: "Stearic Acid",
          url: "https://elchemy.com/product/stearic-acid-192",
        },
        {
          "@type": "ListItem",
          position: 6,
          name: "Glycerin",
          url: "https://elchemy.com/product/glycerin-193",
        },
        {
          "@type": "ListItem",
          position: 7,
          name: "Sodium Bicarbonate",
          url: "https://elchemy.com/product/sodium-bicarbonate-194",
        },
        {
          "@type": "ListItem",
          position: 8,
          name: "Citric Acid Anhydrous",
          url: "https://elchemy.com/product/citric-acid-anhydrous-195",
        },
        {
          "@type": "ListItem",
          position: 9,
          name: "Propylene Glycol",
          url: "https://elchemy.com/product/propylene-glycol-196",
        },
        {
          "@type": "ListItem",
          position: 10,
          name: "Titanium Dioxide",
          url: "https://elchemy.com/product/titanium-dioxide-197",
        },
        {
          "@type": "ListItem",
          position: 11,
          name: "Sodium Sulphate Anhydrous",
          url: "https://elchemy.com/product/sodium-sulphate-anhydrous-198",
        },
        {
          "@type": "ListItem",
          position: 12,
          name: "Potassium Hydroxide",
          url: "https://elchemy.com/product/potassium-hydroxide-199",
        },
        {
          "@type": "ListItem",
          position: 13,
          name: "Sorbitol",
          url: "https://elchemy.com/product/sorbitol-200",
        },
        {
          "@type": "ListItem",
          position: 14,
          name: "Benzyl Alcohol",
          url: "https://elchemy.com/product/benzyl-alcohol-201",
        },
        {
          "@type": "ListItem",
          position: 15,
          name: "Isopropyl Alcohol (IPA)",
          url: "https://elchemy.com/product/isopropyl-alcohol-ipa-202",
        },
      ],
    },
    {
      "@type": "BreadcrumbList",
      "@id": "https://elchemy.com/product/#breadcrumb",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://elchemy.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Products",
          item: "https://elchemy.com/product",
        },
      ],
    },
    {
      "@type": "WebSite",
      "@id": "https://elchemy.com/#website",
      url: "https://elchemy.com/",
      name: "Elchemy",
      publisher: { "@id": "https://elchemy.com/#organization" },
    },
  ],
};

export const getRandomFloat = (min, max, decimals = 1) => {
  const value = Math.random() * (max - min) + min;
  return parseFloat(value.toFixed(decimals));
};

export const getRandomInt = (min, max) => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const buildProductDetailSchema = (product, pageUrl) => ({
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Product",
      "@id": `${pageUrl}#product`,
      name: product.ChemicalName,
      description: product.Productdescription,
      image:
        product.ProductImage ||
        "https://elchemy-website.s3.ap-south-1.amazonaws.com/elchemy-logo/Elchemy_Passion_Innovation_Technology.jpg",
      sku: String(product.id),
      productID: String(product.id),
      category: product.industry_names || [],
      brand: { "@type": "Brand", name: "Elchemy" },
      manufacturer: { "@id": "https://elchemy.com/#organization" },
      additionalProperty: [
        product.Appearance && {
          "@type": "PropertyValue",
          propertyID: "appearance",
          name: "Appearance",
          value: product.Appearance,
        },
        product.CasNumber && {
          "@type": "PropertyValue",
          propertyID: "casNumber",
          name: "CAS Number",
          value: product.CasNumber,
        },
        product.ChemicalFormula && {
          "@type": "PropertyValue",
          propertyID: "chemicalFormula",
          name: "Chemical Formula",
          value: product.ChemicalFormula,
        },
        product.HSCode && {
          "@type": "PropertyValue",
          propertyID: "hsCode",
          name: "HS Code",
          value: product.HSCode,
        },
        product.Packaging && {
          "@type": "PropertyValue",
          propertyID: "packaging",
          name: "Packaging",
          value: product.Packaging,
        },
        product.MolecularWeight && {
          "@type": "PropertyValue",
          propertyID: "molecularWeight",
          name: "Molecular Weight",
          value: product.MolecularWeight,
        },
        product.BoilingPoint && {
          "@type": "PropertyValue",
          propertyID: "boilingPoint",
          name: "Boiling Point",
          value: product.BoilingPoint,
        },
        product.MeltingPoint && {
          "@type": "PropertyValue",
          propertyID: "meltingPoint",
          name: "Melting Point",
          value: product.MeltingPoint,
        },
        product.Density && {
          "@type": "PropertyValue",
          propertyID: "density",
          name: "Density",
          value: product.Density,
        },
      ].filter(Boolean),
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: String(getRandomFloat(4.5, 5.0)),
        reviewCount: String(getRandomInt(30, 300)),
      },
    },
    {
      "@type": "BreadcrumbList",
      "@id": `${pageUrl}#breadcrumb`,
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://elchemy.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Products",
          item: "https://elchemy.com/product",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: product.ChemicalName,
          item: pageUrl,
        },
      ],
    },
  ],
});

export const buildIndustryPageSchema = (
  industryData,
  products,
  faqs,
  pageUrl,
) => ({
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "CollectionPage",
      "@id": `${pageUrl}#webpage`,
      url: pageUrl,
      name:
        industryData?.metaTitle ||
        `${industryData?.name} Ingredient Suppliers | Elchemy`,
      description:
        industryData?.metaDescription || industryData?.description || "",
      isPartOf: { "@id": "https://elchemy.com/#website" },
      publisher: { "@id": "https://elchemy.com/#organization" },
      mainEntity: { "@id": `${pageUrl}#itemlist` },
    },
    {
      "@type": "ItemList",
      "@id": `${pageUrl}#itemlist`,
      name: `Elchemy ${industryData?.name} Chemical Product Range`,
      description: `Bulk chemical supplies and ingredients for the ${industryData?.name} industry.`,
      itemListElement: (products || []).slice(0, 20).map((p, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: p.ChemicalName,
        url: `https://elchemy.com/product/${p.ChemicalName?.toLowerCase()
          .replace(/\s+/g, "-")
          .replace(/[^\w-]+/g, "")}-${p.id}`,
      })),
    },
    ...(faqs?.length
      ? [
          {
            "@type": "FAQPage",
            "@id": `${pageUrl}#faq`,
            mainEntity: faqs.map((faq) => ({
              "@type": "Question",
              name: faq.question || faq.Question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.answer || faq.Answer,
              },
            })),
          },
        ]
      : []),
    {
      "@type": "BreadcrumbList",
      "@id": `${pageUrl}#breadcrumb`,
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://elchemy.com/",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Industries",
          item: "https://elchemy.com/industry",
        },
        {
          "@type": "ListItem",
          position: 3,
          name: industryData?.name,
          item: pageUrl,
        },
      ],
    },
  ],
});

export const ORGANIZATION_SCHEMA = {
  "@context": "https://schema.org",
  "@type": "Organization",
  "@id": "https://elchemy.com/#organization",
  name: "Elchemy",
  legalName: "BizinBiz Technologies Pvt. Ltd.",
  url: "https://elchemy.com/",
  logo: "https://elchemy-website.s3.ap-south-1.amazonaws.com/elchemy-logo/Elchemy_Passion_Innovation_Technology.jpg",
  description:
    "Elchemy is a tech-enabled, cross-border specialty chemical distributor bridging high-quality manufacturers in India and Southeast Asia with commercial end-users and local distributors globally. Supported by a robust local footprint, including dedicated US warehouses, we ensure seamless, compliant, and transparent international chemical procurement.",
  areaServed: [
    "Worldwide",
    "United States",
    "Europe",
    "Middle East",
    "Latin America",
  ],
  founder: [
    {
      "@type": "Person",
      name: "Hardik Seth",
      jobTitle: "Co-Founder",
    },
    {
      "@type": "Person",
      name: "Shobhit Jain",
      jobTitle: "Co-Founder",
    },
  ],
  sameAs: [
    "https://x.com/ElchemyHQ",
    "https://www.facebook.com/ElchemyHQ/",
    "https://www.instagram.com/elchemyhq/?hl=en",
    "https://in.linkedin.com/company/elchemychemicals",
    "https://www.indiamart.com/bizinbiz-technologies-private-limited/about-us.html",
    "https://www.forbes.com/profile/elchemy/",
    "https://chemicalsamerica.com/companies/elchemy-inc",
    "https://www.crunchbase.com/organization/elchemy",
    "https://www.ambitionbox.com/overview/elchemy-overview",
    "https://wellfound.com/company/elchemy/people",
    "https://tracxn.com/d/companies/elchemy/__69ESUnEWXpydgJQuVde6UPXP5EIvkZ4SpFFvy1WTsgg",
    "https://www.glassdoor.co.in/Overview/Working-at-Elchemy-EI_IE7105247.11,18.htm",
    "https://www.preqin.com/data/profile/asset/elchemy/713718",
    "https://pitchbook.com/profiles/company/496122-49#overview",
  ],
  address: [
    {
      "@type": "PostalAddress",
      streetAddress: "3/8 2nd Floor, Asaf Ali Road, Above Dabur India Pvt. Ltd",
      addressLocality: "New Delhi",
      addressRegion: "DL",
      postalCode: "110002",
      addressCountry: "IN",
    },
    {
      "@type": "PostalAddress",
      streetAddress: "302, Donear House, MIDC, Mulgaon, Andheri East",
      addressLocality: "Mumbai",
      addressRegion: "Maharashtra",
      postalCode: "400093",
      addressCountry: "IN",
    },
    {
      "@type": "PostalAddress",
      streetAddress: "100 Somerset Corporate Blvd",
      addressLocality: "Bridgewater",
      addressRegion: "NJ",
      postalCode: "08807",
      addressCountry: "US",
    },
    {
      "@type": "PostalAddress",
      streetAddress: "525 Century Plaza Dr.",
      addressLocality: "Houston",
      addressRegion: "TX",
      postalCode: "77073",
      addressCountry: "US",
    },
    {
      "@type": "PostalAddress",
      streetAddress: "1325 Morse Ave",
      addressLocality: "Elk Grove Village",
      addressRegion: "IL",
      postalCode: "60007",
      addressCountry: "US",
    },
    {
      "@type": "PostalAddress",
      streetAddress: "745 Dillon Dr.",
      addressLocality: "Wood Dale",
      addressRegion: "IL",
      postalCode: "60191",
      addressCountry: "US",
    },
  ],
  contactPoint: [
    {
      "@type": "ContactPoint",
      email: "info@elchemy.com",
      contactType: "Customer Support",
    },
    {
      "@type": "ContactPoint",
      telephone: "+919867099519",
      contactType: "Sales",
    },
    {
      "@type": "ContactPoint",
      telephone: "+1-346-367-9223",
      email: "Dustin.Collins@specialcargo.com",
      contactType: "Logistics and Shipping",
    },
    {
      "@type": "ContactPoint",
      telephone: "+1-929-712-9726",
      email: "rcarter@algworldwide.com",
      contactType: "Logistics and Shipping",
    },
  ],
};

/**
 * JSON-LD for a config-driven landing page (`/markets/[region]/[slug]`).
 *
 * One `@graph` covering WebPage + Service + FAQPage + BreadcrumbList, following
 * the same shape as `buildIndustryPageSchema` above so the two cannot drift.
 *
 * ⚠️ **FAQPage is emitted HERE and nowhere else.** `FAQSection` renders no JSON-LD
 * of its own (verified), so there is no double-emit — but if that ever changes,
 * this block must be dropped rather than duplicated: two FAQPage nodes on one URL
 * is a structured-data error.
 *
 * `pageUrl` MUST be built from `REGION`/`SLUG` values by the caller, never
 * hardcoded, so a URL-scheme change stays a one-line edit in those constants.
 *
 * @param {Object} config  A landing-page config (see constastants/landingPages).
 * @param {string} pageUrl Absolute canonical URL of this page.
 */
export const buildLandingPageSchema = (config, pageUrl) => {
  const faqs =
    config?.sections?.find((s) => s.type === "faq")?.items ?? [];
  const name = config?.seo?.metaTitle || config?.seo?.title || "";
  const description = config?.seo?.description || "";
  // The hero heading is the page's H1 and is the most human-readable label for
  // the service being offered; the SEO title is keyword-shaped and less apt here.
  const heroHeading =
    config?.sections?.find((s) => s.type === "hero" || s.type === "productHero")
      ?.heading || name;

  return {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${pageUrl}#webpage`,
        url: pageUrl,
        name,
        description,
        isPartOf: { "@id": "https://elchemy.com/#website" },
        publisher: { "@id": "https://elchemy.com/#organization" },
        ...(faqs.length ? { mainEntity: { "@id": `${pageUrl}#faq` } } : {}),
      },
      {
        "@type": "Service",
        "@id": `${pageUrl}#service`,
        name: heroHeading,
        description,
        serviceType: heroHeading,
        provider: { "@id": "https://elchemy.com/#organization" },
        // `region` is the URL segment (e.g. "north-america"); Schema.org wants a
        // human-readable place name, so it is de-slugified rather than passed raw.
        areaServed: {
          "@type": "Place",
          name: (config?.region || "")
            .split("-")
            .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
            .join(" "),
        },
      },
      ...(faqs.length
        ? [
            {
              "@type": "FAQPage",
              "@id": `${pageUrl}#faq`,
              mainEntity: faqs.map((faq) => ({
                "@type": "Question",
                name: faq.question,
                acceptedAnswer: { "@type": "Answer", text: faq.answer },
              })),
            },
          ]
        : []),
      {
        "@type": "BreadcrumbList",
        "@id": `${pageUrl}#breadcrumb`,
        itemListElement: [
          {
            "@type": "ListItem",
            position: 1,
            name: "Home",
            item: "https://elchemy.com/",
          },
          {
            "@type": "ListItem",
            position: 2,
            name: heroHeading,
            item: pageUrl,
          },
        ],
      },
    ],
  };
};
